import * as moment from "moment";

export class DayOfWeekSchedule {
  sunday: boolean;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;

  constructor(data?: any) {
    if (data == null) return DayOfWeekSchedule.default();
    this.sunday = data["sunday"];
    this.monday = data["monday"];
    this.tuesday = data["tuesday"];
    this.wednesday = data["wednesday"];
    this.thursday = data["thursday"];
    this.friday = data["friday"];
    this.saturday = data["saturday"];
  }
  public static all(): DayOfWeekSchedule {
    return new DayOfWeekSchedule({
      sunday: true,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true
    });
  }

  static default(): DayOfWeekSchedule {
    return new DayOfWeekSchedule({
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false
    });
  }

  selected(): boolean {
    return (
      this.sunday ||
      this.monday ||
      this.tuesday ||
      this.wednesday ||
      this.thursday ||
      this.friday ||
      this.saturday
    );
  }

  toJSON() {
    return {
      sunday: this.sunday,
      monday: this.monday,
      tuesday: this.tuesday,
      wednesday: this.wednesday,
      thursday: this.thursday,
      friday: this.friday,
      saturday: this.saturday
    };
  }
  toString(disableParenthesis?: boolean): string {
    let x = disableParenthesis ? "" : "(";
    if (this.sunday) x += "Sun, ";
    if (this.monday) x += "Mon, ";
    if (this.tuesday) x += "Tues, ";
    if (this.wednesday) x += "Wed, ";
    if (this.thursday) x += "Thurs, ";
    if (this.friday) x += "Fri, ";
    if (this.saturday) x += "Sat, ";
    x = x.substring(0, x.length - 2);
    if (!disableParenthesis) x += ")";
    return x;
  }

  isInSchedule(date: Date) {
    const weekday = date.getDay();
    switch (weekday) {
      case 0:
        return this.sunday;
      case 1:
        return this.monday;
      case 2:
        return this.tuesday;
      case 3:
        return this.wednesday;
      case 4:
        return this.thursday;
      case 5:
        return this.friday;
      case 6:
        return this.saturday;
    }
  }
}
